import { BaseEdge, EdgeProps, getSmoothStepPath } from "@xyflow/react";

const DottedEdge = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
}: EdgeProps) => {
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  return (
    <BaseEdge
      path={edgePath}
      markerEnd={markerEnd}
      className="text-schemes dark:text-schemes-dk"
      style={{
        ...style,
        stroke: "currentColor",
        strokeDasharray: "3, 3",
        strokeLinecap: "round",
        strokeWidth: 1,
      }}
    />
  );
};

export default DottedEdge;
